import React from 'react';
import PropTypes from 'prop-types';

import {AppFlags} from '../../../app/app-types';
import {connectAppEnv} from '../../../app/app-env';
import {withUILevel} from '../../../lib/react/oe-higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {UIControllerType} from '../../../react-oe/oe-types';
import {OEManualViewLinks} from '../../views/manual-view/oe-manual-view-model';
import OEPopover from '../../views/oe-popover';
import {OEGroupControl, OEControl, OEIconButtonGroupControl, OEToggleCheckboxControl} from '../../elements/controls/oe-controls';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEDefaultConfigFactory} from '../../oe-default-configs';
import retardUpdate from '../../../lib/react/update-retarder';
import {OENoteEditDisplayFlags, OENoteAddFlags, OENoteControllerBtnIds} from './oe-note-model';
import {OEPresetType} from '../preset/oe-preset-model';
import OEPresetDropdown from '../preset/oe-preset-dropdown';
import OEToolbox from '../../../lib/tools/oe-toolbox';

export class OENoteController extends React.PureComponent {

    constructor(props){
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            uiEnabled: false,
            enabled: false,
            isEditingEnabled: false,
            isEditingAddRemoveEnabled: false,
            showDocument: false,
            showVisibilityCheckSize: false,
            addPresetId: -1,
            addFlags: OENoteAddFlags.default,
            strings: {
                title: '',
                enableLabel: '',
                editLabel: '',
                addRemoveLabel: '',
                showDocumentLabel: '',
                showVisibilityCheckSizeLabel: '',
                addOptionsGroupLabel: '',
                presetControlLabel: '',
                addLinkJointLabel: ''
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.updateControlsState = this.updateControlsState.bind(this);
        this.onNotesAddPresetIdChanged = this.onNotesAddPresetIdChanged.bind(this);
        this.onNotesAddFlagsChanged = this.onNotesAddFlagsChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onHelpBtnPressed = this.onHelpBtnPressed.bind(this);
        this.onToolbarButtonPressed = this.onToolbarButtonPressed.bind(this);
        this.onEnableSwitchChanged = this.onEnableSwitchChanged.bind(this);
        this.onEditSwitchChanged = this.onEditSwitchChanged.bind(this);
        this.onEditAddRemoveSwitchChanged = this.onEditAddRemoveSwitchChanged.bind(this);
        this.onShowDocumentSwitchChanged = this.onShowDocumentSwitchChanged.bind(this);
        this.onShowVisibilityCheckSizeSwitchChanged = this.onShowDocumentSwitchChanged.bind(this);
        this.onAddPresetSelected = this.onAddPresetSelected.bind(this);
        this.onAddLinkJointSwitchChanged = this.onAddLinkJointSwitchChanged.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.notesEnabledChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.notesEditModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.notesEditDisplayChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.notesAddPresetIDChanged, this.onNotesAddPresetIdChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.notesAddFlagsChanged, this.onNotesAddFlagsChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.notesEnabledChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.notesEditModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.notesEditDisplayChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.notesAddPresetIDChanged, this.onNotesAddPresetIdChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.notesAddFlagsChanged, this.onNotesAddFlagsChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({strings: {
            title:                  si.getLocalizedStringEnc('note_view'),
            enableLabel:            si.getLocalizedStringEnc('note_view_enable'),
            editLabel:              si.getLocalizedStringEnc('note_view_edit'),
            addRemoveLabel:         si.getLocalizedStringEnc('note_view_add_remove'),
            showDocumentLabel:      si.getLocalizedStringEnc('note_view_show_document'),
            showVisibilityCheckSizeLabel: si.getLocalizedStringEnc('note_view_show_visibility_check_size'),
            addOptionsGroupLabel:   si.getLocalizedStringEnc('note_view_add_options_group'),
            presetControlLabel:     si.getLocalizedStringEnc('note_view_preset_control'),
            addLinkJointLabel:      si.getLocalizedStringEnc('note_view_add_link_joint')
        }});
    }

    updateControlsState()   {
        let note = this.oe.sharedInterface.getUIControllerNote();
        this.setState({
            enabled: note.getEnabled(),
            isEditingEnabled: note.isEditingEnabled(),
            isEditingAddRemoveEnabled: note.isEditingAddRemoveEnabled(),
            showDocument: note.hasEditDisplay(OENoteEditDisplayFlags.showDocument),
            showVisibilityCheckSize: note.hasEditDisplay(OENoteEditDisplayFlags.showVisibilityCheckSize)
        });
    }

    updateControlsAddPresetId(presetID) {
        let ID = typeof(presetID) === 'number' ? presetID : (this.oe.isReady() ? this.oe.sharedInterface.getUIControllerNote().getAddPresetID() : -1);
        this.setState({addPresetId: ID});
    }

    updateControlsAddFlags(flags)   {
        flags = typeof(flags) === 'number' ? flags : (this.oe.isReady() ? this.oe.sharedInterface.getUIControllerNote().getAddFlags() : OENoteAddFlags.default);
        this.setState({addFlags: flags});
    }

    updateUIState()   {
        this.setState({
          uiEnabled: this.oe.sharedInterface.getUIControllerNote().getUIEnabled()
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({
                uiEnabled: false
            });
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateControlsState();
            this.updateUIState();
            this.updateControlsAddPresetId();
            this.updateControlsAddFlags();
        });
    }

    onNotesAddPresetIdChanged(message, userInfo)    {
        this.updateControlsAddPresetId(userInfo.presetID);
    }

    onNotesAddFlagsChanged(message, userInfo)    {
        this.updateControlsAddFlags(userInfo.flags);
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.note) {
            this.updateUIState();
        }
    }

    renderToolbar() {
        if(this.props.config.noToolbar)    return null;

        let buttons = [];
        if(this.props.devFeatures)  {
            buttons = [
                {
                    id: OENoteControllerBtnIds.showDocument,
                    disabled: !(this.state.uiEnabled && this.state.enabled),
                    activated: this.state.showDocument,
                    icon: OEIconCodes.noteShowDocument
                },
                {
                    id: OENoteControllerBtnIds.showVisibilityCheckSize,
                    disabled: !(this.state.uiEnabled && this.state.enabled),
                    activated: this.state.showVisibilityCheckSize,
                    icon: OEIconCodes.noteShowVisibilityCheckSize
                },
                {
                    id: OENoteControllerBtnIds.orderViews,
                    disabled: !(this.state.uiEnabled && this.state.enabled && this.state.isEditingEnabled),
                    icon: OEIconCodes.noteOrderViews
                }
            ];
        }

        if(!buttons.length) return null;

        return (
            <OEIconButtonGroupControl
                className="toolbar"
                buttons={buttons}
                onPressed={this.onToolbarButtonPressed}
            />
        );
    }

    render()    {
        if(!this.props.config.enabled) return null;
        let editSwitchEnabled = this.state.uiEnabled && this.state.enabled;
        let editAddRemoveSwitchEnabled = this.state.isEditingEnabled && editSwitchEnabled;

        return(
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEPopover
                    className="popover-control"
                    placement="right-start"
                    moduleId={this.props.moduleId}
                    uiControllerType={UIControllerType.note}
                    boundariesElement={this.props.boundariesElement}
                    target={this.props.target}
                    buttonClassName="transparent-btn"
                    title={this.state.strings.title}
                    onHelpBtnPressed={this.props.config.showHelpBtn ? this.onHelpBtnPressed : null}
                >
                    <div className="note-controller">
                        <OEGroupControl>

                            {this.renderToolbar()}

                            <OEToggleCheckboxControl
                                className="align-right"
                                title={this.state.strings.enableLabel}
                                active={this.state.enabled}
                                disabled={!this.state.uiEnabled}
                                onClick={this.onEnableSwitchChanged}
                            />

                            <OEToggleCheckboxControl
                                className="align-right"
                                title={this.state.strings.editLabel}
                                active={this.state.isEditingEnabled}
                                disabled={!editSwitchEnabled}
                                onClick={this.onEditSwitchChanged}
                            />

                            <OEToggleCheckboxControl
                                className="align-right"
                                title={this.state.strings.addRemoveLabel}
                                active={this.state.isEditingAddRemoveEnabled}
                                disabled={!editAddRemoveSwitchEnabled}
                                onClick={this.onEditAddRemoveSwitchChanged}
                            />

                            {!(this.props.devFeatures && this.props.config.noToolbar) ? null :
                                <OEToggleCheckboxControl
                                    className="align-right"
                                    title={this.state.strings.showDocumentLabel}
                                    active={this.state.showDocument}
                                    disabled={!editSwitchEnabled}
                                    onClick={this.onShowDocumentSwitchChanged}
                                />
                            }

                            {!(this.props.devFeatures && this.props.config.noToolbar) ? null :
                                <OEToggleCheckboxControl
                                    className="align-right"
                                    title={this.state.strings.showVisibilityCheckSizeLabel}
                                    active={this.state.showVisibilityCheckSize}
                                    disabled={!editSwitchEnabled}
                                    onClick={this.onShowVisibilityCheckSizeSwitchChanged}
                                />
                            }

                        </OEGroupControl>

                        {!this.props.devFeatures ? null :
                            <OEGroupControl 
                                title={this.state.strings.addOptionsGroupLabel}
                                type={OEGroupControl.type.fullCollapsable}
                                collapsed={!this.state.isEditingAddRemoveEnabled}
                                topSeparator={true}
                            >
                                <OEControl 
                                    title={this.state.strings.presetControlLabel}
                                    header={true}
                                >
                                    <OEPresetDropdown
                                        moduleId={this.props.moduleId}
                                        disabled={!this.state.uiEnabled}
                                        presetType={OEPresetType.note}
                                        selectedPresetId={this.state.addPresetId}
                                        onPresetSelected={this.onAddPresetSelected}
                                    />
                                </OEControl>

                                <OEToggleCheckboxControl
                                    className="align-right"
                                    title={this.state.strings.addLinkJointLabel}
                                    active={!!(this.state.addFlags & OENoteAddFlags.linkJoint)}
                                    disabled={!this.state.uiEnabled}
                                    onClick={this.onAddLinkJointSwitchChanged}
                                />

                            </OEGroupControl>
                        }

                    </div>
                </OEPopover>
            </React.Fragment>
        );
    }

    onHelpBtnPressed()  {
        if(this.props.appComponent)    this.props.appComponent.uiLayer.manualView.setOpen(true, {link: OEManualViewLinks.note});
    }

    onToolbarButtonPressed(sender, id)  {
        if(!this.oe.isReady()) return;
        let note = this.oe.sharedInterface.getUIControllerNote();

        if(id === OENoteControllerBtnIds.showDocument)    {
            if(this.state.showDocument) {
                note.removeEditDisplay(OENoteEditDisplayFlags.showDocument);
            } else {
                note.addEditDisplay(OENoteEditDisplayFlags.showDocument);
            }
        } else if(id === OENoteControllerBtnIds.showVisibilityCheckSize)    {
            if(this.state.showVisibilityCheckSize) {
                note.removeEditDisplay(OENoteEditDisplayFlags.showVisibilityCheckSize);
            } else {
                note.addEditDisplay(OENoteEditDisplayFlags.showVisibilityCheckSize);
            }
        } else if(id === OENoteControllerBtnIds.orderViews) {
            note.orderNoteViews();
        }
    }

    onEnableSwitchChanged() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerNote().setEnabled(!this.state.enabled, true, 0.333);
    }

    onEditSwitchChanged() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerNote().enableEditing(!this.state.isEditingEnabled);
    }

    onEditAddRemoveSwitchChanged() {
        if(!this.oe.isReady()) return;
        if(this.oe.sharedInterface.getUIControllerNote().isEditingEnabled()) {
            this.oe.sharedInterface.getUIControllerNote().enableEditingAddRemove(!this.state.isEditingAddRemoveEnabled);
        }
    }

    onShowDocumentSwitchChanged() {
        if(!this.oe.isReady()) return;
        let note = this.oe.sharedInterface.getUIControllerNote();

        if(this.state.showDocument) {
            note.removeEditDisplay(OENoteEditDisplayFlags.showDocument);
        } else {
            note.addEditDisplay(OENoteEditDisplayFlags.showDocument);
        }
    }

    onShowVisibilityCheckSizeSwitchChanged() {
        if(!this.oe.isReady()) return;
        let note = this.oe.sharedInterface.getUIControllerNote();

        if(this.state.showVisibilityCheckSize) {
            note.removeEditDisplay(OENoteEditDisplayFlags.showVisibilityCheckSize);
        } else {
            note.addEditDisplay(OENoteEditDisplayFlags.showVisibilityCheckSize);
        }
    }

    onAddPresetSelected(sender, id) {
        if(!this.oe.isReady()) return;
        let note = this.oe.sharedInterface.getUIControllerNote();
        note.setAddPresetID(id);
    }

    onAddLinkJointSwitchChanged()   {
        if(!this.oe.isReady()) return;
        let note = this.oe.sharedInterface.getUIControllerNote();
        let flags = note.getAddFlags();
        let hasFlag = !!(flags & OENoteAddFlags.linkJoint);
        flags = OEToolbox.binaryAddRemove(flags, OENoteAddFlags.linkJoint, hasFlag);
        note.setAddFlags(flags);
    }
}

OENoteController.defaultProps = {
    moduleId: '',
    target: '',
    config: OEDefaultConfigFactory.noteController(),
    devFeatures: false
};

OENoteController.propTypes = {
    moduleId: PropTypes.string,
    config: PropTypes.shape({
        enabled: PropTypes.bool,
        showHelpBtn: PropTypes.bool,
        noToolbar: PropTypes.bool
    }).isRequired,
    devFeatures: PropTypes.bool
};

export default connectAppEnv((env) => {
    const ui = env.config.module.uiLayerConfig;
    return {
        appComponent: env.component,
        config: OEDefaultConfigFactory.combineShowHelpState(ui.widgetConfig.noteController, ui.widgetConfig.showHelp, ui.manualView.links, OEManualViewLinks.note),
        devFeatures: env.config.module.flags && env.config.module.flags.includes(AppFlags.import)
    }
})(withUILevel(OENoteController));